import { render } from "./StorefrontContent.vue?vue&type=template&id=5947d42d&scoped=true"
import script from "./StorefrontContent.vue?vue&type=script&lang=js"
export * from "./StorefrontContent.vue?vue&type=script&lang=js"

import "./StorefrontContent.vue?vue&type=style&index=0&id=5947d42d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5947d42d"]])

export default __exports__